export default {"src":"/_next/static/media/41-icon.1000eb45.svg","height":39,"width":46,"blurWidth":0,"blurHeight":0};